import React from 'react';
import { Button } from 'react-bootstrap';
import serializeCsv from '../../utils/csv/exportCsv';

const inferColumnsFromData = data => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  const keys = Array.from(
    data.reduce((set, row) => {
      Object.keys(row || {}).forEach(key => set.add(key));
      return set;
    }, new Set())
  );

  return keys.map(key => ({
    header: key,
    key,
  }));
};

const ExportCSVButton = ({ data = [], columns, filename = 'export.csv', number, className }) => {
  const resolvedColumns = columns ?? inferColumnsFromData(data);
  const disabled = resolvedColumns.length === 0;

  const handleDownload = () => {
    if (disabled) {
      return;
    }

    const csv = serializeCsv({
      rows: data,
      columns: resolvedColumns,
    });

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <Button variant="success" onClick={handleDownload} className={className} disabled={disabled}>
      Export{number ? ` (${number})` : ``}
    </Button>
  );
};

export default ExportCSVButton;
